/* eslint-disable max-len */
import React from 'react'

import { string } from 'prop-types'

function Gadgets(props) {
  return (
    <svg {...props} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.6021 14.8389C18.106 14.8902 18.4993 15.3155 18.4995 15.833C18.4995 16.3507 18.1062 16.7768 17.6021 16.8281L17.4995 16.833H2.49951C1.94742 16.8328 1.49951 16.3852 1.49951 15.833C1.49969 15.281 1.94753 14.8332 2.49951 14.833H17.4995L17.6021 14.8389ZM14.9995 4C15.4856 4 15.9516 4.19352 16.2954 4.53711C16.6392 4.88085 16.8324 5.3469 16.8325 5.83301V12.5C16.8325 12.9862 16.6392 13.4521 16.2954 13.7959C15.9516 14.1396 15.4856 14.333 14.9995 14.333H4.99951C4.51343 14.3329 4.04733 14.1396 3.70361 13.7959C3.35993 13.4521 3.1665 12.9861 3.1665 12.5V5.83301C3.16659 5.34699 3.36 4.88083 3.70361 4.53711L3.8374 4.41504C4.16354 4.14779 4.57418 4.0001 4.99951 4H14.9995ZM5.1665 12.333H14.8325V6H5.1665V12.333Z"
        fill="#35424F"
      />
    </svg>
  )
}

Gadgets.propTypes = {
  className: string,
  height: string,
  width: string,
}

export default Gadgets
